import React from 'react'

import GuidesList from 'components/Guides'
import data from './data'

const Guides = (): React.ReactElement => (
  <GuidesList
    articles={data.articles}
    title={data.title}
    readMore={data.readMore}
  />
)

export default Guides
